import { render, staticRenderFns } from "./ContactAccountTypeForm.vue?vue&type=template&id=54633140&scoped=true&"
import script from "./ContactAccountTypeForm.vue?vue&type=script&lang=js&"
export * from "./ContactAccountTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactAccountTypeForm.vue?vue&type=style&index=0&id=54633140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54633140",
  null
  
)

export default component.exports